module.exports = __webpack_public_path__ + "img/fm-Path 36 Copy@3x.5aa09b73.png";